// extracted by mini-css-extract-plugin
module.exports = {"steps":"BaseSteps_steps_1B35c","step":"BaseSteps_step_33vUh","step__number":"BaseSteps_step__number_2OQ02","is-process":"BaseSteps_is-process_1ho9c"};